import { render, staticRenderFns } from "./table.wht54.vue?vue&type=template&id=27e54820"
import script from "./table.wht54.vue?vue&type=script&lang=js"
export * from "./table.wht54.vue?vue&type=script&lang=js"
import style0 from "./table.wht54.vue?vue&type=style&index=0&id=27e54820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports